export enum ProjectStatus {
  ONGOING = "Ongoing",
  DONE = "Done"
}

export enum ProjectBelongsTo {
  ALL = "All",
  VENDELLIGENT = "Vendelligent",
  CLASS = "CLASS - FZCO",
  SOFTBANK = "SoftBank",
  PERSONAL = "Personal Project",
}

export enum ProjectRoleType {
  ALL = "All",
  SOFTWARE_ENGINEERING = "Software Engineering",
  DATA_SCIENTIST = "Data Scientist",
}

export interface Project {
  id: string;
  title: string;
  status: ProjectStatus;
  summary?: string;
  role?: string;
  techStack: string[];
  url: string;
  imageEnvVar: string;
  belongTo: ProjectBelongsTo;
  roleType: ProjectRoleType;
  disableBlur?: boolean;
  priority?: number;
}
